import type {ReactElement} from 'react';
import {FontItem} from '@Components/font-selector-panel/components/font-item';
import type {OnDeleteFontItemCallback, OnSelectFontFamilyCallback} from '@Components/font-selector-panel/font-selector.types';
import type {FontData} from '@Libraries/font-library';

interface FontsListProps {
  className?: string;
  fontNames: FontData[];
  isUserUploadedFontList?: boolean;
  onSelectFontFamily?: OnSelectFontFamilyCallback;
  selectedFontFamily?: string;
  isSelectedFontLoading?: boolean;

  onDeleteFontItem?: OnDeleteFontItemCallback;
}

export function FontsList({
  className = '',
  isUserUploadedFontList = false,
  onDeleteFontItem = (): void => {},
  onSelectFontFamily = (): void => {},
  selectedFontFamily = '',
  isSelectedFontLoading = false,
  ...props
}: FontsListProps): ReactElement<any> | null {
  const onClickHandler = (font: FontData): void => {
    onSelectFontFamily(font);
  };

  const onDeleteFontItemHandler = (font: FontData): void => {
    onDeleteFontItem(font);
  };

  // An empty selectedFontFamily means "no font is selected" (e.g. a group with mixed fonts) and must
  // highlight nothing — do not fall back to a globally-tracked font.
  const isFontSelected = (fontFamily: string): boolean => {
    return selectedFontFamily !== '' && selectedFontFamily === fontFamily;
  };

  const prepItems = (): ReactElement<any>[] | null => {
    if (!props.fontNames) {
      return null;
    }

    return props.fontNames.map((fontName) => {
      return (
        <FontItem
          showDeleteActions={isUserUploadedFontList}
          onDelete={(): void => {
            onDeleteFontItemHandler(fontName);
          }}
          onClick={(): void => {
            onClickHandler(fontName);
          }}
          key={fontName.idfont}
          fontName={fontName.fontFamily}
          isSelected={isFontSelected(fontName.fontFamily)}
          isLoading={isSelectedFontLoading}
        />
      );
    });
  };

  return <ul className={`${className} spacing-m-0`}>{prepItems()}</ul>;
}
